import router from '../../router'

export interface State {
  isLoggedIn: boolean
  isAuthLoading: boolean
}

export interface Context {
  commit: (name: string, payload: object) => void
  dispatch: (name: string, payload?: any, options?: any) => void
}

export interface Mutations {
  [key: string]: (state: State, payload?: any) => void
}

export interface Actions {
  [key: string]: (this: any, context: Context, payload?: any) => void
}

export const initialState: State = {
  isLoggedIn: false,
  isAuthLoading: false
}

export const mutations: Mutations = {
  onLoadingStart(state) {
    state.isAuthLoading = true
  },
  onLoadingFinished(state) {
    state.isAuthLoading = false
  },
  handleLogin(state) {
    state.isLoggedIn = true
  },
  handleLogout(state) {
    state.isLoggedIn = false
  }
}

export const actions: Actions = {
  async login({ commit, dispatch }, payload) {
    commit('onLoadingStart', {})
    const { response } = await this.$api.postSignIn(payload)
    if (response) {
      const now = new Date()
      now.setDate(now.getDate() + 20)
      document.cookie = `auth_status=success; expires=${now.toUTCString()}`
      commit('handleLogin', {})

      await this.$delay(500)
      commit('onLoadingFinished', {})
      router.push('/home')
      return
    }
    await this.$delay(500)
    dispatch(
      'flash/setMessage',
      {
        message: 'ログインできませんでした',
        isAlert: true
      },
      {
        root: true
      }
    )
    commit('onLoadingFinished', {})
  },
  async logout({ commit, dispatch }) {
    document.cookie = 'auth_status=; max-age=0'
    commit('handleLogout', {})
    router.push('/signin')
    dispatch(
      'flash/setMessage',
      {
        message: 'ログアウトしました',
        isAlert: false
      },
      {
        root: true
      }
    )
  },
  async checkLoggedIn({ commit }) {
    const hasLoggedIn = document.cookie.includes('auth_status')

    if (hasLoggedIn) {
      commit('handleLogin', {})
      return
    }
    commit('handleLogout', {})
  },
  async resetPassword({ dispatch }, payload) {
    const { error } = await this.$api.postResetPassword(payload)
    if (!error) {
      dispatch(
        'flash/setMessage',
        {
          message: 'メールを送信しました',
          isAlert: false
        },
        {
          root: true
        }
      )
    }
  }
}

export default {
  namespaced: true,
  state: () => initialState,
  mutations,
  actions
}
